import React, { useEffect, useState } from 'react';

import { useLazyQuery, useMutation } from '@apollo/client';
import {
  Link,
  FormControlLabel,
  Checkbox,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import { themeColors } from 'muiTheme';
import authService from 'services/Auth';
import IntermediaryBusinessRequests from 'services/IntermediaryBusiness/gqlSchema';

import { AcceptedTermsConditions } from './utils/utils';

const IntermediaryBusinessAutoActivationDialog = () => {
  const [open, setOpen] = useState(false);
  const [chechedCGS, setChechedCGS] = useState(false);

  // uncomment for production, usefull to test
  //const isAgent = authService.getContact().isAgent;
  const currentContactInfo = authService.getContactInfo();
  const bu = currentContactInfo?.company?.code.toLowerCase();

  const cguApporteursPdf =
    'https://s3.eu-central-1.amazonaws.com/assets.digitregroup.io/intranet/apporteurs/Projet+CGU-VDEF_Conseillers+modif+16122022%5B41%5D.pdf';

  const [fetchIntermediaryBusinessConfig] = useLazyQuery(
    IntermediaryBusinessRequests.Query.intermediaryBusinessConfigActivationAuto,
    {
      fetchPolicy: 'no-cache',
      onCompleted: data => {
        const agentConfig = data.intermediaryBusinessConfig;

        if (
          agentConfig?.dateEnd === null &&
          agentConfig?.acceptedTermsConditions === AcceptedTermsConditions.UNTOUCHED
        ) {
          setOpen(true);
        }
      },
    },
  );

  const [intermediaryBusinessCloseConfigMutation] = useMutation(
    IntermediaryBusinessRequests.Mutation.intermediaryBusinessCloseConfig,
  );

  const [intermediaryBusinessAcceptInitialConfigMutation] = useMutation(
    IntermediaryBusinessRequests.Mutation.intermediaryBusinessAcceptInitialConfig,
  );

  useEffect(() => {
    if (currentContactInfo?.id) {
      fetchIntermediaryBusinessConfig({
        variables: {
          contactsInfoId: currentContactInfo.id,
        },
      });
    }
  }, [currentContactInfo, fetchIntermediaryBusinessConfig]);

  const handleResponse = async value => {
    if (value === AcceptedTermsConditions.DENIED) {
      await intermediaryBusinessCloseConfigMutation({
        variables: { contactsInfoId: currentContactInfo?.id, acceptedTermsConditions: value },
      });
    }

    if (value === AcceptedTermsConditions.ACCEPTED) {
      await intermediaryBusinessAcceptInitialConfigMutation({
        variables: { contactsInfoId: currentContactInfo?.id },
      });
    }

    setOpen(false);
  };

  // uncomment for production, usefull to test
  /* if (!isAgent) {
    return null;
  } */

  return (
    <Dialog
      id={'intermediary-business-initializer'}
      open={open}
      aria-labelledby='intermediary-business-dialog-title'
      disableEscapeKeyDown
    >
      <DialogTitle
        id='intermediary-business-dialog-title'
        sx={{ color: bu ? 'white' : 'inherit', backgroundColor: bu ? themeColors[bu].MAIN : 'none', marginBottom: 2 }}
      >
        Ton dispositif Apporteur d'Affaires
      </DialogTitle>
      <DialogContent sx={{ paddingBottom: 0 }}>
        <Typography mb={2}>
          Avec ton dispositif Apporteur d’Affaires, gagne des mandats grâce à tes amis, collègues ou connaissances qui
          te recommandent des biens à vendre et rémunère-les à hauteur de 10% de tes honoraires si la vente a lieu !
        </Typography>
        <FormControlLabel
          control={<Checkbox checked={chechedCGS} onChange={event => setChechedCGS(event.target.checked)} />}
          label={
            <div>
              Je reconnais avoir pris connaissance{' '}
              <Link href={cguApporteursPdf} target='_blank' rel='noopener,noreferrer'>
                des Conditions Générales d'Utilisation du service Apporteur d'Affaires et du cadre fiscal
              </Link>
            </div>
          }
        />
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', paddingY: 3 }}>
        <Button
          id='deactivate-intermediary-business'
          onClick={() => handleResponse(AcceptedTermsConditions.DENIED)}
          variant='outlined'
        >
          Désactiver
        </Button>
        <Button
          id='accept-intermediary-business'
          onClick={() => handleResponse(AcceptedTermsConditions.ACCEPTED)}
          disabled={!chechedCGS}
          color={'primary'}
          variant='contained'
          sx={{ backgroundColor: bu ? themeColors[bu].MAIN : 'none' }}
        >
          C'est parti !
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IntermediaryBusinessAutoActivationDialog;
